// absolute imports
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import ClassNames from 'classnames/bind';
import get from 'lodash/get';
import noop from 'lodash/noop';
import isEmpty from 'lodash/isEmpty';
import User from 'yoda-site-components/lib/helpers/User/User';
// account component
import LayoutHelmet from 'yoda-site-components/lib/components/CAMNav/LayoutHelmet';
import Canonincalize from 'yoda-account-components/lib/components/Canonincalize/Canonincalize';
import CAMErrorComponent from 'yoda-account-components/lib/components/CAMErrorComponent/CAMErrorComponent';
import MyAppointments from 'yoda-account-components/lib/components/MyAppointments/MyAppointments';
import Loader from 'yoda-core-components/lib/components/Loader/Loader';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
// relative imports
import * as styles from './Appointments.css';

const cx = ClassNames.bind(styles);
const defaultObject = {};
class Appointments extends Component {
    static defaultProps = {
        messagesTexts: {},
        appointmentDetails: {},
        preferences: {},
        actions: { appointmentPageLoaded: noop },
        sliderActions: { openSignInSlider: noop },
        userState: '',
        location: '',
        locationServiceStoreInfo: {},
    };

    static propTypes = {
        messagesTexts: PropTypes.objectOf(PropTypes.object),
        appointmentDetails: PropTypes.oneOfType([PropTypes.object]),
        preferences: PropTypes.oneOfType([PropTypes.object]),
        actions: PropTypes.objectOf(PropTypes.func),
        sliderActions: PropTypes.objectOf(PropTypes.func),
        userState: PropTypes.string,
        location: PropTypes.oneOfType([PropTypes.object]),
        locationServiceStoreInfo: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.isAuthenticationTriggered = false;
    }

    componentDidMount() {
        const {
            actions: { appointmentPageLoaded },
            locationServiceStoreInfo,
        } = this.props;
        // only call api on load  when User is logged in
        User.isUserLoggedIn() &&
            this.props.actions.getAppointmentLink('', locationServiceStoreInfo?.storeId || null);
        appointmentPageLoaded && appointmentPageLoaded();
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        const isStateOfUserChanged =
            this.isAuthenticationTriggered &&
            this.service &&
            this.props.userState &&
            nextProps.userState === '1';
        if (isStateOfUserChanged) {
            this.onCardClick(this.service, true);
            this.isAuthenticationTriggered = false;
        }
        if (
            this.props.locationServiceStoreInfo?.storeId !==
            nextProps?.locationServiceStoreInfo?.storeId
        ) {
            User.isUserLoggedIn() &&
                nextProps?.actions.getAppointmentLink(
                    '',
                    nextProps?.locationServiceStoreInfo?.storeId || null
                );
        }
    }

    /**
     * This function is only used for
     * guest on Click on Appointment Card
     */
    onCardClick = (service, retryOnAuth = false) => {
        // store for auth success
        if (!retryOnAuth) this.service = service;
        const {
            actions: { getAppointmentLink },
            sliderActions: { openSignInSlider },
            locationServiceStoreInfo,
        } = this.props;
        if (User.isUserLoggedIn()) {
            this.setState(
                // eslint-disable-next-line react/no-unused-state
                { isLoading: true },
                () =>
                    typeof getAppointmentLink === 'function' &&
                    getAppointmentLink(service, locationServiceStoreInfo?.storeId || null)
            );
        } else {
            openSignInSlider();
            this.isAuthenticationTriggered = true;
        }
    };

    render() {
        const {
            appointmentDetails,
            messagesTexts,
            preferences,
            actions,
            location: { pathname = '' },
        } = this.props;
        const list = get(preferences, 'list', []);
        const [isExternalLinks, appointmentData, appointmentError] = [
            get(preferences, 'isExternalLinks', true),
            get(appointmentDetails, 'allStores.data'),
            get(appointmentDetails, 'allStores.error'),
        ];
        const hrefMap = appointmentData;
        const componentProps = {
            hrefMap,
            list,
            messagesTexts,
            isExternalLinks,
            onCardClick: this.onCardClick,
        };
        const isLoading = get(appointmentDetails, 'allStores.isLoading');
        defaultObject.title = get(this.props.messagesTexts, 'pageTitle');

        return (
            <>
                <LayoutHelmet layoutState={defaultObject} />
                <Canonincalize urlLocation={pathname} />
                <section className={cx('appointmentContainer')}>
                    {isLoading && <Loader keepOverlay />}
                    {isLoading === false &&
                    (!isEmpty(appointmentError) || isEmpty(appointmentData)) ? (
                        !isEmpty(get(preferences, 'serviceDownError')) && (
                            <CAMErrorComponent
                                classes={{
                                    wrapper: `${cx('appointmentErrorCard')} ${dt([
                                        'h-full',
                                        'text-center',
                                        'bg-white',
                                    ])}`,
                                }}
                                errorDetails={get(preferences, 'serviceDownError')}
                                hideRetryButton={
                                    !!get(preferences, 'serviceDownError.hideRetryButton')
                                }
                                onRetry={() => {
                                    actions.getAppointmentLink();
                                }}
                                buttonTitle={get(preferences, 'serviceDownError.buttonTitle')}
                            />
                        )
                    ) : (
                        /* eslint-disable-next-line react/jsx-props-no-spreading */
                        <MyAppointments {...componentProps} />
                    )}
                </section>
            </>
        );
    }
}

export default Appointments;
